/**
 * Mock body stats service.
 * Mirrors the real body-stats.service.js API with in-memory data.
 */
import { MOCK_BODY_STATS } from '../../data/mock/mock-body-stats.data';
import { mockDelay, mockLog, mockId } from './mock-delay';

// In-memory state
let bodyStats = [...MOCK_BODY_STATS];

export const addBodyStats = async (userId, data) => {
  mockLog('BodyStatsService', 'addBodyStats', data);
  await mockDelay();
  const entry = {
    id: `mock_bs_${mockId()}`,
    date: (data.date instanceof Date ? data.date : new Date(data.date)).toISOString(),
    weight: data.weight ?? null,
    bodyFatPercentage: data.bodyFatPercentage ?? null,
    measurements: {
      chest: data.measurements?.chest ?? null,
      waist: data.measurements?.waist ?? null,
      hips: data.measurements?.hips ?? null,
      arms: data.measurements?.arms ?? null,
      thighs: data.measurements?.thighs ?? null,
    },
    notes: data.notes || '',
    createdAt: new Date().toISOString(),
  };
  bodyStats = [...bodyStats, entry].sort((a, b) => new Date(a.date) - new Date(b.date));
  return entry;
};

export const getBodyStats = async (userId, startDate, endDate) => {
  mockLog('BodyStatsService', 'getBodyStats', { startDate, endDate });
  await mockDelay();
  const start = new Date(startDate);
  const end = new Date(endDate);
  return bodyStats
    .filter((s) => {
      const d = new Date(s.date);
      return d >= start && d <= end;
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const getLatestBodyStats = async (userId) => {
  mockLog('BodyStatsService', 'getLatestBodyStats', userId);
  await mockDelay();
  if (bodyStats.length === 0) return null;
  return bodyStats[bodyStats.length - 1];
};

export const deleteBodyStats = async (userId, entryId) => {
  mockLog('BodyStatsService', 'deleteBodyStats', entryId);
  await mockDelay();
  bodyStats = bodyStats.filter((s) => s.id !== entryId);
  return entryId;
};
